import { t } from "../../validation/validator";
import { CallResponseMixinSchema, CallResponseSchema } from "../common/callResponseSchema";
import { stripeBillingDetailsRequestSchema, stripeBillingDetailsSchema } from "./stripeBilling.schemas";
import { couponResponseSchema, stripeGetCouponRequestSchema } from "./stripeCoupon.schemas";
import {
  stripeGetInvoicesRequestSchema,
  stripeGetUpcomingInvoiceRequestSchema,
  stripeInvoiceListResponseSchema,
  stripeUpcomingInvoiceResponseSchema,
} from "./stripeInvoice.schemas";
import {
  createSubscriptionResponseSchema,
  stripeCancelScheduledSubscriptionUpdateRequestSchema,
  stripeCreateSubscriptionRequestSchema,
  stripeGetSubscriptionDetailsRequestSchema,
  stripeGetSubscriptionDetailsResponseSchema,
  stripeSubscriptionPriceSchema,
  stripeUpdateSubscriptionDataSchema,
  stripeUpdateSubscriptionRequestSchema,
} from "./stripeSubscription.schemas";

// Re-export all coupon types and schemas
export * from "./stripeCoupon.schemas";

// Re-export all discount types and schemas
export * from "./stripeDiscount.schemas";

// Re-export all invoice types and schemas
export * from "./stripeInvoice.schemas";

// Re-export all subscription types and schemas
export * from "./stripeSubscription.schemas";

// ─── API Configuration ───────────────────────────────────────────────────────

export const StripeApis = {
  Stripe: {
    BillingDetails: {
      Name: "stripe-billingDetails",
      Request: stripeBillingDetailsRequestSchema,
      Response: t.type({ data: stripeBillingDetailsSchema }),
    },
    GetSubscriptionDetails: {
      Name: "stripe-getSubscriptionDetails",
      Request: stripeGetSubscriptionDetailsRequestSchema,
      Response: stripeGetSubscriptionDetailsResponseSchema,
    },
    GetInvoices: {
      Name: "stripe-getInvoices",
      Request: stripeGetInvoicesRequestSchema,
      Response: t.intersection([t.type({ data: stripeInvoiceListResponseSchema }), CallResponseMixinSchema]),
    },
    GetProducts: {
      Name: "stripe-temp-getProducts",
      Request: t.type({}),
      Response: t.intersection([t.type({ data: t.array(stripeSubscriptionPriceSchema) }), CallResponseMixinSchema]),
    },
    GetUpcomingInvoice: {
      Name: "stripe-getUpcomingInvoice",
      Request: stripeGetUpcomingInvoiceRequestSchema,
      Response: t.intersection([t.type({ data: stripeUpcomingInvoiceResponseSchema }), CallResponseMixinSchema]),
    },
    GetCoupon: {
      Name: "stripe-getCoupon",
      Request: stripeGetCouponRequestSchema,
      Response: t.type({ coupon: couponResponseSchema }),
    },
    UpdateSubscription: {
      Name: "stripe-updateSubscription",
      Request: stripeUpdateSubscriptionRequestSchema,
      Response: t.union([
        t.intersection([t.type({ data: stripeUpdateSubscriptionDataSchema }), CallResponseMixinSchema]),
        stripeUpdateSubscriptionDataSchema,
        CallResponseSchema,
      ]),
    },
    CancelSubscription: {
      Name: "stripe-cancelSubscription",
      Request: t.partial({
        user_id: t.string,
        subscription_id: t.string,
      }),
      Response: CallResponseSchema,
    },
    CancelScheduledSubscriptionUpdate: {
      Name: "stripe-cancelScheduledSubscriptionUpdate",
      Request: stripeCancelScheduledSubscriptionUpdateRequestSchema,
      Response: CallResponseSchema,
    },
    CreateSubscription: {
      Name: "stripe-createSubscription",
      Request: stripeCreateSubscriptionRequestSchema,
      Response: t.intersection([t.type({ data: createSubscriptionResponseSchema }), CallResponseMixinSchema]),
    },
  },
};
